import React, {Component} from 'react';
import PropTypes from 'prop-types';
import shouldUpdate from 'recompose/shouldUpdate';
import {TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import DatagridCell from 'admin-on-rest/lib/mui/list/DatagridCell';

/**
 * The DatagridBodyWithContentRow component duplicates the AOR DatagridBody, which renders a list of records as a table.
 * It handles the list and includes a row for full-width data.
 *
 */
class DatagridBodyWithContentRow extends Component {
    render() {
        const {
            resource,
            children,
            columns,
            contentKey,
            data,
            basePath,
            ids,
            isLoading,
            styles,
            options,
            rowOptions,
            rowStyle,
            uniqueKey,
            ...rest
        } = this.props;

        const tableStyles = {
            mainRow: {borderBottom: 'none'},
            dataRow: {height: 'auto', backgroundColor: '#f6f6f6'},
            closed: {
                display: 'none',
                height: 0,
                fontSize: 0,
                lineHeight: 0,
                padding: 0,
                borderBottom: 'none',
                overflow: 'hidden',
            },
            open: {
                display: 'table-cell',
                padding: '10px 15px 10px 20px',
                height: 'auto',
                fontSize: 12,
                color: '#666666',
                borderBottom: 'none',
                overflow: 'visible',
                whiteSpace: 'inherit',
            },
            content: {
                display: 'block',
                width: 'auto',
            },
            noBorder: {
                borderBottom: 'none',
            },
        };

        return (
            <TableBody
                displayRowCheckbox={false}
                className="datagrid-body"
                {...rest}
                {...options}
            >
                {ids.map((id, rowIndex) => {
                        if (id) {
                            return (
                                [
                                    <TableRow
                                        style={tableStyles.mainRow}
                                        id={id + '-' + rowIndex}
                                        key={id + '-' + rowIndex}
                                        selectable={false}
                                        {...rowOptions}
                                    >
                                        {React.Children.map(
                                            children,
                                            (field, index) =>
                                                field ? (
                                                    <DatagridCell
                                                        key={`${uniqueKey}-${(field.props.source + '-' + index) || index}`}
                                                        className={`column-${field.props.source}`}
                                                        record={data[id]}
                                                        defaultStyle={
                                                            index === 0 ? (
                                                                styles.cell['td:first-child']
                                                            ) : (
                                                                styles.cell.td
                                                            )
                                                        }
                                                        {...{field, basePath, resource}}
                                                    />
                                                ) : null
                                        )}
                                    </TableRow>,
                                    <TableRow style={tableStyles.dataRow}>
                                        <TableRowColumn
                                            key={`content-row-cell-${uniqueKey}`}
                                            id={`content-row-cell-${uniqueKey}-${rowIndex}`}
                                            className="content-row-cell open"
                                            colSpan={columns}
                                            style={tableStyles.open}
                                        >
                                            <div style={tableStyles.content}>
                                                {data[id][contentKey]}
                                            </div>
                                        </TableRowColumn>
                                    </TableRow>
                                ]
                            )
                        }
                        return null;
                    }
                )}
            </TableBody>
        )
    }
}

DatagridBodyWithContentRow.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool,
    resource: PropTypes.string,
    contentKey: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    basePath: PropTypes.string,
    options: PropTypes.object,
    rowOptions: PropTypes.object,
    styles: PropTypes.object,
    rowStyle: PropTypes.func,
    uniqueKey: PropTypes.string,
};

DatagridBodyWithContentRow.defaultProps = {
    data: {},
    contentKey: 'name',
    ids: [],
    uniqueKey: 'id',
};

const PureDatagridBodyWithContentRow = shouldUpdate(
    (props, nextProps) => nextProps.isLoading === false
)(DatagridBodyWithContentRow);

// trick material-ui Table into thinking this is one of the child type it supports
PureDatagridBodyWithContentRow.muiName = 'TableBody';

export default PureDatagridBodyWithContentRow;



// WEBPACK FOOTER //
// ./src/Fuse/admin/DatagridBodyWithContentRow.js